import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { cn } from "@/lib/utils";

interface OfflineIndicatorProps {
  className?: string;
}

/**
 * Shows a banner when the device is offline
 */
export function OfflineIndicator({ className }: OfflineIndicatorProps) {
  const { isOnline } = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 z-[100] bg-destructive text-destructive-foreground",
        "flex items-center justify-center gap-2 py-2 px-4 text-sm font-medium",
        "safe-area-top animate-fade-in",
        className
      )}
    >
      <WifiOff className="h-4 w-4" />
      <span>You're offline</span>
    </div>
  );
}
